import { Timer } from "lucide-react";
import type { WidgetDef } from "../types";
import { ShiftGlance, ShiftView } from "./ShiftWidget";
import { ShiftSettings } from "./ShiftSettings";

export interface ShiftConfig {
  /** "HH:MM", xodimning o'z vaqtida; tunga o'tishi mumkin (18:00-03:00) */
  start: string;
  end: string;
}

const HM = /^([01]\d|2[0-3]):[0-5]\d$/;

export const defaultShiftConfig = (): ShiftConfig => ({ start: "09:00", end: "18:00" });

export function parseShiftConfig(raw: unknown): ShiftConfig {
  const d = defaultShiftConfig();
  if (!raw || typeof raw !== "object") return d;
  const r = raw as Record<string, unknown>;
  const ok = typeof r.start === "string" && typeof r.end === "string" && HM.test(r.start) && HM.test(r.end) && r.start !== r.end;
  return ok ? { start: r.start as string, end: r.end as string } : d;
}

export const shiftWidget: WidgetDef<ShiftConfig> = {
  type: "shift",
  icon: Timer,
  title: "shift.title",
  description: "shift.description",
  sizes: ["s", "m"],
  defaultSize: "s",
  defaultConfig: defaultShiftConfig,
  parseConfig: parseShiftConfig,
  available: (me) => me.role !== "carrier",
  View: ShiftView,
  Glance: ShiftGlance,
  Settings: ShiftSettings,
};
